import { Injectable } from '@angular/core';
import { CrudService } from '../crud.service';
import { HttpClient } from '@angular/common/http';
import { Topic } from '../../models/topic';

@Injectable({
  providedIn: 'root',
})
export class TopicService extends CrudService<Topic> {
  protected basePath = 'topic'; // Specific for TopicService
  public instanceType = 'theme'; // Used in base service for constructing URLs

  constructor(http: HttpClient) {
    super(http);
  }
}
